import "./Error404.scss";
export default function Error404() {
    return (
        <h1>Error 404</h1>
    );
}
